module.exports = __webpack_public_path__ + "static/img/read.png";